export const classNamePrefix = 'request-details'

export const approversModalMessage = {
  all: 'All members of the group have to approve.',
  any: 'Any member of the group can approve.',
}
